import React, { ErrorInfo, ReactNode } from "react";
import { NoxusEmptyBlock } from "./UI/NoxusEmptyBlock";
import { CircleX } from "lucide-react";
import * as Sentry from "@sentry/nextjs";
interface State {
  hasError: boolean;
}
interface Props {
  children?: ReactNode;
  fallback?: ReactNode;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }

  //----- Resets hasError to false
  resetState() {
    this.setState({ hasError: false });
  }

  componentDidMount() {
    window.onpopstate = () => {
      this.resetState();
    };
  }

  componentWillUnmount() {
    window.onpopstate = null;
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI

    return { hasError: true };
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can use your own error logging service here
    // We can send a message to slack here
    console.error("------------------");
    console.error({ error, errorInfo });
    console.error("------------------");
    Sentry.captureException(error, {
      extra: {
        errorInfo,
      },
    });
  }
  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <NoxusEmptyBlock
          icon={CircleX}
          title="Something went wrong"
          description="We have been notified and are looking into this issue."
          linkButton={"Go to home"}
          link={"/"}
        />
      );
    }

    // Return children components in case of no error

    return this.props.children;
  }
}

export default ErrorBoundary;
